import {connect} from 'react-redux'

import {toggleBooking} from '../planner/planner.action'

import {Booking} from './booking.component'

const mapStateToProps = (state) => {
    let legs = state.getIn(['document', 'legs']).sortBy((leg) => { return leg.getIn(['properties', 'start']) })
  
    return {
        legs: legs,
        tripGuid: state.getIn(['document', 'properties', 'tripGuid']),
        itinGuid: state.getIn(['document', 'properties', 'itineraryGuid']),
        allTransportation: state.getIn(['document', 'transportation']),
        travelers: state.getIn(['document', 'travelers']),
        properties: state.getIn(['document', 'properties']),
        lunaTrip: state.get('lunaTrip')
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onToggleBooking: () => {
            dispatch(toggleBooking())
        },
    }
}

const BookingContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Booking)

export default BookingContainer
